import { motion } from "framer-motion";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import { useAuth, ROLE_LABEL } from "@/context/AuthContext";
import ThemeToggle from "@/components/ThemeToggle";
import { initials, LOGO_URL, APP_NAME, APP_SUB } from "@/components/common";


export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen overflow-x-hidden">
      <header className="sticky top-0 z-40 glass" style={{ borderRadius: 0, borderLeft: 0, borderRight: 0, borderTop: 0 }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Logo" className="h-11 w-11 object-contain drop-shadow" />
            <div className="leading-tight">
              <p className="font-extrabold text-emerald-950 dark:text-emerald-50 tracking-tight">{APP_NAME}</p>
              <p className="text-[11px] text-emerald-700 dark:text-emerald-300 hidden sm:block">{APP_SUB} · Monitoring Santri</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden sm:flex items-center gap-2.5">
              <Avatar className="h-9 w-9 ring-2 ring-white dark:ring-white/10">
                <AvatarImage src={user?.picture} />
                <AvatarFallback className="bg-emerald-100 text-emerald-700 text-xs">{initials(user?.name)}</AvatarFallback>
              </Avatar>
              <div className="leading-tight">
                <p className="text-sm font-semibold text-emerald-950 dark:text-emerald-50 max-w-[140px] truncate">{user?.name}</p>
                <Badge className="border-0 text-[10px] px-1.5 py-0 bg-amber-100 text-amber-800">{ROLE_LABEL[user?.role]}</Badge>
              </div>
            </div>
            <ThemeToggle />
            <Button data-testid="logout-button" variant="outline" size="sm" onClick={logout}
              className="gap-2 rounded-full bg-white/60 dark:bg-white/5 border-emerald-200 dark:border-white/10">
              <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Keluar</span>
            </Button>
          </div>
        </div>
      </header>
      <motion.main initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: "easeOut" }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-10 pb-28 md:pb-10">
        {children}
      </motion.main>
    </div>
  );
}
